module.exports = __webpack_public_path__ + "img/7right-e597b6c7.png";